import { Component, OnInit, Input } from '@angular/core';
import { LocalService } from '../../../service/local.service';

@Component({
  selector: 'app-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss']
})
export class LabelComponent implements OnInit {
  @Input() Text: string = ''; @Input() IsMandatory = false; @Input() IsAllMandatory = false; @Input() IsPartiallyMandatory = false;
  @Input() IsNeedNewLine = false; @Input() HelpKey: number = null; @Input() IsColonRequired = true; @Input() isWrap = false;
  @Input() IsBold = false; @Input() LanguageCode = ''; @Input() color: string = '#008CBA'; @Input() IsColonRight = false;

  constructor(public localService: LocalService) { }

  ngOnInit(): void {
    if (!this.LanguageCode) {
      this.LanguageCode = this.localService.selectedLanguageCode;
    }
  }

}
